import UserRehydratedGate from './UserRehydratedGate';

export default UserRehydratedGate;